import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useIsAuth0Configured } from '../auth/auth0_configuration';
import { UploadDataPage } from './upload_data_page';

function UploadDataPageWithAuth() {
  const { logout } = useAuth0();

  const handleSignOut = () => {
    void logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return <UploadDataPage onSignOut={handleSignOut} />;
}

const AuthenticatedUploadDataPage = withAuthenticationRequired(UploadDataPageWithAuth, {
  returnTo: () => '/admin/upload-data',
  onRedirecting: () => (
    <div
      role="status"
      aria-label="Redirecting to sign in"
      className="app-gradient flex min-h-[calc(100dvh-3.5rem)] items-center justify-center px-6"
    >
      <p className="surface-card p-6 font-black text-qs-navy">Redirecting to sign in...</p>
    </div>
  ),
});

export function UploadDataRoute() {
  const isAuth0Configured = useIsAuth0Configured();

  if (!isAuth0Configured) {
    return (
      <div className="app-gradient min-h-[calc(100dvh-3.5rem)] py-12">
        <section className="mx-auto w-full max-w-2xl px-6">
          <div role="alert" className="surface-card p-6 sm:p-8">
            <h1 className="text-2xl font-black text-qs-navy">Authentication is not configured</h1>
            <p className="mt-3 leading-7 text-aws-slate">
              Set VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID, and VITE_AUTH0_AUDIENCE, then restart
              the frontend to enable secure data uploads.
            </p>
          </div>
        </section>
      </div>
    );
  }

  return <AuthenticatedUploadDataPage />;
}
